<template>
  <div class="modal" :class="{'is-active': config.isActive}">
    <div class="modal-background" @click="close()"></div>
    <div class="modal-card" :class="{'is-large': config.isLarge}">
      <header class="modal-card-head">
        <slot name="header"></slot>
        <button class="modal-close is-large" aria-label="close" @click="close()"></button>
      </header>
      <section class="modal-card-body">
          <slot></slot>
      </section>
      <footer class="modal-card-foot">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
import Scrollable from '@/components/scrollable.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { IModal } from './';

@Component({
  name: 'Modal',
  components: { Scrollable }
})
class Modal extends Vue {
  @Prop({ required: true }) public config!: IModal;
  public created() {}
  public close() {
    if (this.config.close) {
      this.config.close();
    } else {
      if (this.config.onClose) {
        this.config.onClose();
      }

      this.config.isActive = false;
    }
  }
}

export default Modal;
</script>

<style lang="scss">
@import "./src/bulma/components/modal";

.modal {
  .modal-card-foot:empty {
    display: none;
  }
  .modal-card-body {
    max-height: 84vh;
    overflow: auto;
  }
  .modal-card-head {
    .title {
      margin: 0 !important;
    }
  }
}
</style>